var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5010_3959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.149 45.503C7.32066 47.082 0.82596 40.4847 2.40055 35.6545C2.64273 34.9115 3.70107 34.897 3.96711 35.6318C5.25566 39.191 8.56618 42.6122 12.1589 43.931C12.8995 44.2028 12.8989 45.2578 12.149 45.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9734 46.5369L35.7391 47.7056C35.489 48.9598 34.4182 49.89 33.1359 49.9671C27.8452 50.2847 22.763 48.298 19.106 44.5331C18.7501 44.1667 18.8153 43.5687 19.2337 43.2759C19.4285 43.1397 19.6182 42.9918 19.8025 42.8327C20.3684 42.3435 22.6207 39.9905 26.177 37.7346C26.5663 37.4878 27.0789 37.6042 27.3281 37.9921C28.859 40.3759 31.2181 42.2303 34.1963 43.3452C35.4984 43.8327 36.2453 45.1754 35.9734 46.5369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1507 5.52299C42.4151 5.52299 42.0349 4.62695 42.5614 4.10039L43.4485 3.2133C43.7739 2.88788 44.3015 2.88788 44.6269 3.2133C44.9525 3.53872 44.9525 4.06632 44.6269 4.39174L43.7399 5.27883C43.5773 5.44164 43.364 5.52299 43.1507 5.52299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7483 11.924C36.0127 11.924 35.6325 11.0279 36.1591 10.5014L39.5663 7.09416C39.8917 6.76874 40.4193 6.76874 40.7447 7.09416C41.0702 7.41958 41.0702 7.94718 40.7447 8.2726L37.3375 11.6798C37.1749 11.8426 36.9616 11.924 36.7483 11.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0628 6.82006C31.5092 6.82006 31.1072 6.28839 31.2619 5.75453L32.7556 0.601606C32.8836 0.159417 33.3462 -0.0949583 33.788 0.033167C34.2301 0.161292 34.4846 0.623481 34.3564 1.06556L32.8628 6.21849C32.757 6.58308 32.4241 6.82006 32.0628 6.82006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8527 16.6119C41.4912 16.6119 41.1583 16.375 41.0527 16.0104C40.9246 15.5683 41.179 15.1061 41.6211 14.978L46.7741 13.4843C47.2161 13.3562 47.6783 13.6107 47.8064 14.0528C47.9346 14.4949 47.6801 14.957 47.238 15.0852C41.5976 16.72 42.0212 16.6119 41.8527 16.6119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2494 31.2711C42.6403 32.8801 40.0325 32.8813 38.4223 31.2711L16.5816 9.4304C14.9754 7.8231 14.9754 5.20956 16.5816 3.6033C18.1895 1.9934 20.7987 1.99111 22.4087 3.6033L44.2494 25.444C45.8557 27.0502 45.8557 29.6638 44.2494 31.2711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9847 31.918C30.7963 33.2196 27.2392 34.9184 23.9728 37.1959C23.6568 37.4163 23.2312 37.3904 22.9435 37.1341C19.0344 33.6518 14.5847 29.2404 10.7181 24.9065C10.462 24.6195 10.4375 24.194 10.6574 23.8785C12.9339 20.6124 14.6333 17.0556 15.9341 12.8675C16.1202 12.2687 16.8754 12.0811 17.3187 12.5245L35.3277 30.5334C35.7711 30.9768 35.5836 31.7319 34.9847 31.918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3583 37.9508C21.7375 38.2918 21.7239 38.8872 21.3322 39.2136C20.523 39.8879 19.7272 40.6043 18.9386 41.365C12.9852 47.111 0.92421 34.6803 6.4886 28.9139C7.24954 28.1251 7.96547 27.329 8.63964 26.52C8.96527 26.1291 9.55954 26.1137 9.89996 26.4917C13.5129 30.5038 17.6612 34.6269 21.3583 37.9508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5010_3959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.48c3912da79e819a5e80ec8a3e3b1f1f.svg";
export { ForwardRef as ReactComponent };